<!-- .dropcart -->
<div [class]="{
    'dropcart': true,
    'dropcart--style--dropdown': type === 'dropdown',
    'dropcart--style--offcanvas': type === 'offcanvas',
    'dropcart--open': state.isOpen$|async
}">
    <div *ngIf="type === 'offcanvas'" class="dropcart__backdrop" (click)="close()"></div>
    <div class="dropcart__body">
        <div *ngIf="type === 'offcanvas'" class="dropcart__header">
            <div class="dropcart__title">{{"shopping_cart"|translate}}</div>
            <button class="dropcart__close" type="button" (click)="close()">
                <app-icon name="cross-12" size="12"></app-icon>
            </button>
        </div>

        <div class="dropcart__empty" *ngIf="!(cart.cartItems$|async)?.length">
            {{"cart_empty"|translate}}
        </div>
        <ng-container *ngIf="(cart.cartItems$|async)?.length">
            <div *ngFor="let cart of cart.cartItems$|async">
            <div class="dropcart__products-list">
                <div *ngFor="let item of cart.items" class="dropcart__product">

                    <div class="dropcart__product-image product-image">
                        <a

                            class="product-image__body"
                            [routerLink]="((item.sector) ? ['sector', item.sector] : ['/']).concat([item.product.layout || item.product.type, item.product.seo?.slug])"
                            (click)="closeMenu.emit()"
                        >
                            <img class="product-image__img" [src]="(imagebObjectKey(item.product?.images)) ? item.product.images[imagebObjectKey(item.product.images)]?.url : image" alt="">
                        </a>
                    </div>
                    <div class="dropcart__product-info">
                        <div class="dropcart__product-name">
                            <a [routerLink]="((item.sector) ? ['sector', item.sector] : ['/']).concat([item.product.layout || item.product.type, item.product.seo?.slug])" (click)="closeMenu.emit()">{{ translateHelper.localize(item.product.name) }}</a>
                        </div>

                        <app-options-details [options]="item.options"  [variant]="item.variant"></app-options-details>


                            <div class="mx-4" *ngIf="item.serviceData" >
                                <app-booking-details [serviceData]="item.serviceData" [dateType]="item.product?.dateType" [timeType]="item.product?.timeType"></app-booking-details>
                            </div>
                        <div class="dropcart__product-meta">

                            <span class="dropcart__product-quantity">{{ item.amount }}</span> ×
                            <span class="dropcart__product-price" *ngIf="!item.product.hidePrice">{{ item.unitTotalTaxed|currencyFormat }}</span>
                            <span class="dropcart__product-price" *ngIf="item.product.hidePrice">-</span>
                        </div>
                    </div>

                    <button *ngIf="!(route.url === '/checkout')" type="button" class="dropcart__product-remove btn btn-light btn-sm btn-svg-icon" (click)="remove(item,cart._id)" [ngClass]="{'btn-loading': removedItems.includes(item)}">
                        <app-icon name="cross-10" size="10"></app-icon>
                    </button>
                </div>
            </div>
            </div>

            <!-- <div class="dropcart__totals">
                <table>
                    <tr >
                        <th>Subtotal</th>
                        <td>{{ cart.subtotal$|currencyFormat }}</td>
                    </tr>
                    <tr>
                        <th>Shipping</th>
                        <td>{{ cartItems.shippingTotal|currencyFormat  }}</td>
                    </tr>
                    <tr>
                        <th>Taxes</th>
                        <td>{{ cartItems.taxesTotal|currencyFormat  }}</td>
                    </tr>
                    <tr>
                        <th>Total</th>
                        <td>{{ cartItems.total|currencyFormat }}</td>
                    </tr>
                </table>
            </div> -->

            <div class="dropcart__buttons">
                <a class="btn btn-secondary" [routerLink]="['/cart']" (click)="closeMenu.emit()">{{"view_cart"|translate}}</a>
                <!-- <a class="btn btn-primary" [routerLink]="['/checkout']" (click)="closeMenu.emit()">Checkout</a> -->
            </div>
        </ng-container>
    </div>
</div>
<!-- .dropcart / end -->
